/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    FIND_ASSIGNABLE_ASSETS_FOR_ADDON,
    SortDirectionEnum,
} from '@gripp/shared-logic';
import { InfiniteDataGrid } from '@gripp/shared-ui';
import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAddonAssetColumns } from './useAddonAssetColumns';

export type AddonAssetsAssignmentListProps = {
  workspaceId: string;
  addonId: string;
  maxHeight?: number;
  keyword?: string;
  assignments: string[];
  updateAssignments: (assignments: string[]) => void;
};

export const AddonAssetsAssignmentList = ({
  workspaceId,
  addonId,
  maxHeight,
  keyword,
  assignments,
  updateAssignments,
}: AddonAssetsAssignmentListProps) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<any>(() => {
    if (assignments && workspaceId) {
      return {
        keyword,
        addonId,
        assignments,
        workspaceId,
      };
    }
    return undefined;
  });
  const columns = useAddonAssetColumns() as ColumnDef<any, any>[];

  useEffect(() => {
    setFilter({
      keyword,
      addonId,
      assignments,
      workspaceId,
    });
  }, [keyword, addonId, workspaceId, assignments]);

  if (!filter) return null;

  return (
    <InfiniteDataGrid
      modelName="asset"
      hideResultsLabel={true}
      query={FIND_ASSIGNABLE_ASSETS_FOR_ADDON}
      filter={filter}
      pageSize={100}
      columns={columns}
      listMaxHeight={maxHeight as number}
      containerStyle={{ height: maxHeight }}
      paddingBottom={0}
      textEmpty={t('assets.textEmpty')}
      dataPrefix="addon.findAssignableAssetsForAddon"
      orderBy={{ field: 'name', order: SortDirectionEnum.Asc }}
      updateRowsSelected={(rows) => {
        updateAssignments(rows.map((row) => row.id));
      }}
      isRowSelected={(row) => {
        return assignments.includes(row.id);
      }}
      enableScrollRefresh={true}
      showScrollIndicator={true}
    />
  );
};
